export default {
  TEMPLATE: 'Template',
  TEMPLATE_NAME: 'Template name',
  DEFAULT_TEMPLATES: 'Default templates',
  CUSTOM_TEMPLATES: 'Custom templates',
  NEW_TEMPLATE: 'Create new template',
  EDIT_TEMPLATE: 'Edit template',
  DELETE_EMAIL_TEMPLATE: 'Custom email template deleted successfully',
  ADD_EMAIL_TEMPLATE: 'Custom email template added successfully',
  UPDATE_EMAIL_TEMPLATE: 'Custom email template updated successfully',
  EMAIL_SUBJECT: 'Email subject line',
  EMAIL_HEADER: 'Email header',
  EMAIL_CONTENT: 'Email body content',
  CONTENT_SUBTEXT1: "Use the tags above to auto-fill each lead's info in your email. Just copy and paste in the email. E.g. ",
  CONTENT_SUBTEXT2: 'Hi {lead_first_name}',
  CONTENT_SUBTEXT3: ', → becomes →',
  CONTENT_SUBTEXT4: 'Hi John',
  LINKS_HEADING: 'Your requested information',
  LINKS_INFO: 'Links to the shared content will be added automatically in the email',
  HEADER_INFO: 'Shown at the top of the email, just above the main message.',
  NO_DATA: 'No attachments',
  SAVE_TEMPLATE: 'Save template',
  SELECT_TEMPLATE: 'Sélectionner un modèle d’e-mail',
  EMAIL_TEMPLATE_INFO: 'Le contenu sélectionné sera envoyé en pièce jointe avec le message électronique ci-dessous.',
  TEMPLATE_POPUP_TITLE: 'Définir un modèle d’e-mail par défaut?',
  TEMPLATE_POPUP_INFO: 'Voulez-vous définir ce modèle d’e-mail comme modèle par défaut?',
  TEMPLATE_SUCCESS: 'Modèle par défaut défini avec succès'
}
